import * as React from 'react';
import PropTypes from 'prop-types';

const SvgLogosFacebookXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M13.343 2H2.661A.662.662 0 002 2.66v10.67c0 .364.297.661.661.661H8.41V9.348H6.844v-1.81H8.41V6.206c0-1.55.95-2.391 2.33-2.391.661 0 1.232.05 1.399.072v1.618h-.958c-.751 0-.9.355-.9.88v1.156h1.795l-.234 1.81h-1.56V14h3.058a.662.662 0 00.66-.66V2.66a.655.655 0 00-.656-.66z" />
    </svg>
  )
);
SvgLogosFacebookXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgLogosFacebookXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgLogosFacebookXsmall;
